import { useState } from 'react';
import { SearchFormValues } from '@/features/mua-hang/bao-cao-mua-hang/bao-cao-tinh-trang-don-hang-mua/schema';
import { useAuth } from '@/contexts/auth-context';
import api from '@/lib/api';

export const useBaoCaoTinhTrangDonHangMua = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { entity } = useAuth();

  const submitBaoCaoTinhTrangDonHangMua = async (data: SearchFormValues): Promise<any> => {
    if (!entity?.slug) throw new Error('Entity not found');

    setIsLoading(true);
    try {
      const response = await api.post(
        `/entities/${entity.slug}/erp/mua-hang/bao-cao-mua-hang/bao-cao-tinh-trang-don-hang-mua/`,
        data
      );
      return response.data;
    } catch (error) {
      console.error('Error submitting purchase report:', error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    submitBaoCaoTinhTrangDonHangMua
  };
};
